import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)
const router = new Router({
	scrollBehavior: () => ({ y: 0 }),
	routes: [
		{
			path: '/index',
			name: 'index',
			component: resolve => require(['@/pages/index/Index'], resolve)
		},
		// {
		// 	path: '/combClickDemo',
		// 	name: 'combClickDemo',
		// 	component: resolve => require(['@/pages/index/combClickDemo'], resolve)
		// },
		{
			path: '/partner',
			name: 'partner',
			component: resolve => require(['@/pages/partner/Partner'], resolve)
		},
		{
			path: '/service',
			name: 'service',
			component: resolve => require(['@/pages/service/Service'], resolve)
		},
		{
			path: '/introduce',
			name: 'introduce',
			component: resolve => require(['@/pages/introduce/Introduce'], resolve),
			children: [
				{
					path: "index",
					component: resolve => require(['@/pages/introduce/index/Index'], resolve),
				},
				{
					path: "news_01",
					component: resolve => require(['@/pages/introduce/news/News_01'], resolve),
				},
			]

		},
		// 优质房源
		{
			path: '/projectContracting',
			name: 'projectContracting',
			component: resolve => require(['@/pages/projectContracting/projectContracting'], resolve)
		},

		// banner 详情
		{
			path: '/BannerDetail',
			name: 'bannerDetail',
			component: resolve => require(['@/pages/activity/BannerDetail.vue'], resolve)

		},
		// 关于我们
		{
			path: '/aboutUs',
			name: 'aboutUs',
			component: resolve => require(['@/pages/about/aboutUs'], resolve)
		},
		// 新闻资讯
		{
			path: '/news',
			name: 'news',
			component: resolve => require(['@/pages/news/news'], resolve)
		},
		// 绿地建机
		{
			path: '/greenlandConstructionMachinery',
			name: 'greenlandConstructionMachinery',
			component: resolve => require(['@/pages/introduceSinglePage/greenlandConstructionMachinery'], resolve)
		},
		// 劳务采购
		{
			path: '/laborProcurement',
			name: 'LaborProcurement',
			component: resolve => require(['@/pages/laborProcurement/LaborProcurement'], resolve)
		},
		// 事业部活动页
		{
			path: '/businessUnitActivities',
			name: 'BusinessUnitActivities',
			component: resolve => require(['@/pages/activity/BusinessUnitActivities'], resolve)
		},
		// 系统升级
		{
			path: '/systemUpgrade',
			name: 'SystemUpgrade',
			component: resolve => require(['@/pages/systemUpgrade/SystemUpgrade'], resolve)
		},
		{
			path: '*',
			component: resolve => require(['@/pages/index/Index'], resolve)
		}
	]
})

router.beforeEach((to, from, next) => {
	//百度pvuv统计代码
	_hmt.push(['_web_etrade', to.path]);

	next()
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js